import api from './api';

/**
 * The admin email previews: the catalog of emails the exchange sends, and
 * one of them rendered from sample data for one recipient role. The server
 * sends nothing and writes nothing for either call.
 */
export const emailPreviewService = {
    async listEvents() {
        const response = await api.get('/admin/email-previews');
        return response.data;
    },
    async getPreview(event, role) {
        const response = await api.get(
            `/admin/email-previews/${encodeURIComponent(event)}`,
            { params: { role } }
        );
        return response.data;
    },
};

export default emailPreviewService;
